var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoucher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.311,
    height: 11.512,
    style: {
      padding: "0 4px"
    },
    viewBox: "0 0 19.311 11.512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff; padding: 3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -103.385)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 103.385)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.754,107.47a.557.557,0,0,0,.557-.557v-2.971a.557.557,0,0,0-.557-.557H6.5v2.785a.557.557,0,0,1-1.114,0v-2.785H.557a.557.557,0,0,0-.557.557v2.971a.557.557,0,0,0,.557.557,1.671,1.671,0,1,1,0,3.342.557.557,0,0,0-.557.557v2.971a.557.557,0,0,0,.557.557H5.385v-2.785a.557.557,0,1,1,1.114,0V114.9H18.754a.557.557,0,0,0,.557-.557v-2.971a.557.557,0,0,0-.557-.557,1.671,1.671,0,1,1,0-3.342ZM6.5,109.884a.557.557,0,1,1-1.114,0V108.4a.557.557,0,1,1,1.114,0Z",
    transform: "translate(0 -103.385)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoucher);
export default __webpack_public_path__ + "static/media/voucher.8de73d8547c653631a55ba69f09e38f6.svg";
export { ForwardRef as ReactComponent };